import { toast } from 'react-toastify';
import { getGstOverviewService } from './service';
import { GstOverviewResponse } from './types';

export async function fetchGstOverviewData(orgId: string): Promise<GstOverviewResponse | null> {
    try {
        const response = await getGstOverviewService(orgId);
        return (response?.data?.responseBody ?? response?.data) as GstOverviewResponse;
    } catch (err) {
        console.error('Error fetching GST overview data', err);
        toast.error('Failed to load GST overview data');
        return null;
    }
}
